/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-placeholder',['require','underscore','jquery','backbone','activities/scenario-activity'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  //var Marionette = require('marionette');

  var ScenarioActivity = require('activities/scenario-activity');
  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityPlaceholder = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    el: '<div data-role="scenario-activity" class="scenario-activity">',
    template: _.template('<div data-role="activity-content" class="activity-content"></div>'),
    options: { },

    radio: Backbone.Wreqr.radio.channel('global').vent,
    suspended: false,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      //this.options = _.assign(this.options, this.model.get('options'));

      //this.setLayout();
      //this.setInterface();
      setTimeout($.proxy(this.activityReady, this), 1000);
    },

    onRender: function()
    {
      this.get('.option-poor').on('click', $.proxy(this.onOptionClick, this, 'poor'));
      this.get('.option-average').on('click', $.proxy(this.onOptionClick, this, 'average'));
      this.get('.option-good').on('click', $.proxy(this.onOptionClick, this, 'good'));
    },

    onOptionClick: function($perf, evt)
    {
      //console.log('perf', $perf, evt);
      this.performance = $perf;
      this.finish();
    },

    onMediaEnded: function(e)
    {
      ////console.log('BaseScreen::onMediaEnded');
    },

    onBeforeDestroy: function()
    {
      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    finish: function()
    {
      this.get('.option-poor').off('click', $.proxy(this.onOptionClick, this, 'poor'));
      this.get('.option-average').off('click', $.proxy(this.onOptionClick, this, 'average'));
      this.get('.option-good').off('click', $.proxy(this.onOptionClick, this, 'good'));

      ScenarioActivity.prototype.finish.apply(this);
    }

  /*****************************************************************************************************************///}

  });

  return ActivityPlaceholder;

});

